const colors = {
  bg: "#000000",
  text: "#ffffff",
  textMuted: "#a0a0a0",
  accent: "#10B981",
  buttonText: "#ffffff",
};

const baseUrl = "https://agence8020.com";
const logoUrl = `${baseUrl}/signature/logo-signature.png`;

interface SignatureData {
  name: string;
  title: string;
  phone: string;
  email: string;
  calUrl: string;
  photoUrl: string;
}

export function generateSignatureHtml(data: SignatureData): string {
  const phoneClean = data.phone.replace(/\D/g, "");
  const photoSrc = data.photoUrl || `${baseUrl}/signature/signature-photo.jpg`;

  return `
<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; font-size: 13px; line-height: 1.5; background-color: ${colors.bg}; padding: 18px; border-radius: 6px; max-width: 500px;">
  <tr>
    <td style="vertical-align: top; padding-right: 20px; width: 100px;">
      <img src="${photoSrc}" alt="${data.name}" width="100" height="100" style="border-radius: 6px; object-fit: cover; display: block; margin-bottom: 10px;" />
      <img src="${logoUrl}" alt="Agence 8020" width="50" style="display: block; margin: 0 auto;" />
    </td>
    <td style="vertical-align: top;">
      <table cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td>
            <strong style="font-size: 18px; color: ${colors.text}; font-weight: bold;">${data.name}</strong>
          </td>
        </tr>
        <tr>
          <td style="padding-top: 2px; padding-bottom: 10px;">
            <span style="color: ${colors.textMuted}; font-size: 13px;">${data.title}</span><br />
            <span style="color: ${colors.textMuted}; font-size: 13px; font-weight: 600;">Agence 8020</span>
          </td>
        </tr>
        <tr>
          <td style="padding-bottom: 12px;">
            <div style="width: 140px; height: 2px; background-color: ${colors.accent};"></div>
          </td>
        </tr>
        <tr>
          <td style="padding-bottom: 5px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td style="padding-right: 8px; vertical-align: middle;">
                  <span style="color: ${colors.accent}; font-size: 14px;">📞</span>
                </td>
                <td>
                  <a href="tel:+1${phoneClean}" style="color: ${colors.accent}; text-decoration: underline; font-size: 13px;">${data.phone}</a>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding-bottom: 5px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td style="padding-right: 8px; vertical-align: middle;">
                  <span style="color: ${colors.accent}; font-size: 14px;">✉️</span>
                </td>
                <td>
                  <a href="mailto:${data.email}" style="color: ${colors.accent}; text-decoration: underline; font-size: 13px;">${data.email}</a>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td style="padding-right: 8px; vertical-align: middle;">
                  <span style="color: ${colors.accent}; font-size: 14px;">🌐</span>
                </td>
                <td>
                  <a href="https://agence8020.com" style="color: ${colors.accent}; text-decoration: underline; font-size: 13px;">agence8020.com</a>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td colspan="2" style="padding-top: 16px; text-align: center;">
      <a href="${data.calUrl}" target="_blank" style="display: inline-block; background-color: ${colors.accent}; color: ${colors.buttonText}; text-decoration: none; font-size: 13px; font-weight: 600; padding: 10px 28px; border-radius: 6px;">Prendre rendez-vous</a>
    </td>
  </tr>
</table>`.trim();
}
